import { push } from 'features/tracking/datalayer'

export const pushTrackingEvent = (
  action: 'open-dialog' | 'submit',
  shareMethod?: 'copy_url' | 'whatsapp' | 'e-mail'
) => {
  push({
    event: 'genericEvent',
    eventname: 'share_product',
    action: action,
    share_method: shareMethod
  })
}
